import React from "react";
import { Card, Container, Row } from "react-bootstrap";
import PlaceholderImage from "../../../sharedComponents/placeholderImage";
import Loader from "../../../sharedComponents/preloader";
import "../home.scss";

export default function badgeCard({ latestBadge, history }) {
	const badgeDetails = (latestBadge) => {
		return (
			<Container>
				<Row className="row">
					<p className="title">You Won a New Badge</p>
				</Row>
				<Row className="row">
					<PlaceholderImage
						src={latestBadge.badge_data && latestBadge.badge_data.image}
						width={60}
						height={60}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
						className="my-2"
					/>
				</Row>
				<Row className="row">
					<p className="title blue-color">{latestBadge.badge_data && latestBadge.badge_data.name}</p>
				</Row>
				<Row className="row">
					<p className="more-detials-text" onClick={() => history.push("/my-badges")}>
						More Details
					</p>
				</Row>
			</Container>
		);
	};

	const noBadgeMessage = () => {
		return (
			<Container>
				<Row className="row">
					<PlaceholderImage
						src={require("../../../assets/images/no-badge.png")}
						width={60}
						height={60}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
						className="mx-3 my-1"
					/>
				</Row>
				<Row className="row mt-2">
					<p className="title">No Badges Available</p>
				</Row>
				<Row className="row">
					<p className="more-detials-text" onClick={() => history.push("/my-badges")}>
						More Details
					</p>
				</Row>
			</Container>
		);
	};

	return (
		<Card className="card-2">
			<Card.Body className="card2-body">
				{latestBadge === null ? (
					<Loader />
				) : latestBadge && latestBadge.length ? (
					badgeDetails(latestBadge[0])
				) : (
					noBadgeMessage()
				)}
			</Card.Body>
		</Card>
	);
}
